"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

require("./FileInput.css");

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

require("../../Typography/Paragraph/Paragraph.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName File Input
 */
function FileInput(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      id = _ref.id;
  var useStyles = (0, _styles.makeStyles)({
    root: {
      color: _Colors.default.sinineVaal,
      '&:after': {
        content: '"'.concat(children).concat('"')
      }
    }
  });
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("label", {
    className: classes.root.concat(' custom-file-input paragraph css-14')
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "times",
    color: _Colors.default.sinineVaal,
    margin: "3px",
    size: "18px"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    id: id,
    multiple: true,
    onChange: onChange
  }));
}

FileInput.propTypes = {
  /** Elements to be rendered as children of this component */
  children: _propTypes.default.string,

  /** Gets called when the user clicks on the button */
  onChange: _propTypes.default.func,

  /** Id of input element */
  id: _propTypes.default.string
};
FileInput.defaultProps = {
  children: 'Vali dokument',
  onChange: function onChange(event) {
    // eslint-disable-next-line no-console
    console.log('You have clicked me!', event.target);
  }
};
var _default = FileInput;
exports.default = _default;